var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0253906H513V342.018H0V0.0253906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0253906H513V114.023H0V0.0253906Z",
    fill: "#E05206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 228.021H513V342.018H0V228.021Z",
    fill: "#0DB02B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 203.084C274.208 203.084 288.562 188.729 288.562 171.021C288.562 153.314 274.208 138.959 256.5 138.959C238.792 138.959 224.438 153.314 224.438 171.021C224.438 188.729 238.792 203.084 256.5 203.084Z",
    fill: "#E05206"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.0214844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNe);
export default __webpack_public_path__ + "static/media/NE.f8e251a2396c239f3c6e48fd2e24cc64.svg";
export { ForwardRef as ReactComponent };